import Styles from './JobBoard.module.scss'
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//packages
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';


//views
import { AvailableJobs } from './AvailableJobs/AvailableJobs';
import { AppliedJobs } from './AppliedJobs/AppliedJobs';
import { useAPI } from 'components/lib';

export function JobBoard() {
    const [value, setValue] = useState('Available Jobs');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const { data, loading } = useAPI('/api/hiring/profile');

    useEffect(() => {
        if (data) {
            if (data.createProfile) {
                navigate('/hiring/profile')
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    return (
        <div className={Styles.ancestorContainer}>
            <button onClick={() => { navigate('/hiring/resume') }} id='resumeButton' className={Styles.resumeButton}
            >
                View Profile
            </button>
            <TabContext value={value} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: 'white', paddingTop: '10px', zIndex: 10 }}>
                    <TabList onChange={handleChange} sx={{ fontSize: '32px', fontWeight: 600 }}>
                        <Tab label="Available Jobs" value="Available Jobs" sx={{ fontSize: '16px', fontWeight: 600, color: '#3b3b3b' }} />
                        <Tab label="Applied Jobs" value="Applied Jobs" sx={{ fontSize: '16px', fontWeight: 600, color: '#3b3b3b' }} />
                    </TabList>
                </Box>
                <TabPanel value="Available Jobs" sx={{}} >
                    <AvailableJobs />
                </TabPanel>
                <TabPanel value="Applied Jobs">
                    <AppliedJobs />
                </TabPanel>

            </TabContext>
        </div>
    )
}